import React, { Fragment, useEffect } from "react";
import Header from "../../Header/Header";
import PageTitle from "../../pagetitle/PageTitle";
import Footer from "../../footer/Footer";
import Scrollbar from "../../scrollbar/scrollbar";

import DataSolutions from "./DataSolutions";

const DataSolutionssinglepage: React.FC = () => {
    useEffect(() => {
        document.title = "Data Solutions | Brain Machine AI";
      }, []);
    return (
        <Fragment>
            <div className='about-page inner-page'>
                <div className="body_wrap o-clip">
                    <Header />
                    <main>
                    <PageTitle pageTitle="Data Solutions" pagesub="Data Solutions" />
                       <DataSolutions></DataSolutions>
                    </main>
                    <Footer />
                    <Scrollbar />
                </div>
            </div>
        </Fragment>
    );
};

export default DataSolutionssinglepage;
